import en from './en'
import hr from './hr'

const resources = {
  en,
  hr
}

export default resources
